// removed by extract-text-webpack-plugin
module.exports = {"navigation":"_2u4nYXcOy-fYrQ4OQSxZBA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/navigation.scss
// module id = 454
// module chunks = 0